<template>
<div>
  <div v-show="!chatVisibility" class="open-button" id="open-button" @click="showChat()">
    <i class="fas fa-comment-alt"></i>
  </div>

  <div v-show="chatVisibility" class="main-card" id="chatBoxID">
    <div class="header-chat" id="header-chat">
      <div class="logo-title">
        <img
          src="https://www.advancetelecom.com.br/wp-content/uploads/2020/04/advance-logo-1.png"
          width="200"
        />
      </div>

      <div class="button-close" @click="hideChat()">
        <i class="fas fa-times-circle"></i>
      </div>

    </div>

    <div class="chat-area" id="message-box">
      <p class="intro">Em que posso ajudar?</p>
      <div
        class="message-bubble max-lines"
        v-for="msg in messages" :key="msg.text"
        :class="[msg.type == 'received' ? 'received' : 'sent']"
      >
        <span>{{ msg.text }}</span>
        <small>{{ msg.date }}</small>
      </div>
    </div>

    <div class="input-div">
      <input
        class="input-message"
        autocomplete="off"
        name="message"
        type="text"
        id="message"
        @keyup.enter="send()"
      />
      <button class="input-send" autocomplete="off" @click="send()">
        <i class="fas fa-paper-plane"></i>
      </button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      chatVisibility: false,
      messages: [
        {
            text: "Mensagem recebida 1",
            date: "2022-11-14 17:48:00",
            type: "received"
        },
        {
            text: "Mensagem enviada 1",
            date: "2022-11-14 17:51:22",
            type: "sent"
        },
        {
            text: "Mensagem recebida 2",
            date: "2022-11-14 17:52:45",
            type: "received"
        },
        {
            text: "Mensagem enviada 2",
            date: "2022-11-14 17:51:22",
            type: "sent"
        },
        {
            text: "Mensagem recebida 3",
            date: "2022-11-14 17:52:45",
            type: "received"
        },
        {
            text: "Mensagem enviada 3",
            date: "2022-11-14 17:51:22",
            type: "sent"
        },
        {
            text: "Mensagem recebida 4",
            date: "2022-11-14 17:52:45",
            type: "received"
        },
        {
            text: "Mensagem enviada 4",
            date: "2022-11-14 17:51:22",
            type: "sent"
        }
      ],
    };
  },
  methods: {
    sendMessage() {
      var msg = document.getElementById("message").value;
      document.getElementById("message").value = "";

      if (msg == "") return;

      if (!bot_room && !cnpj) {
        cnpj = true;
        socket.emit("setClientName", msg);
      }

      socket.emit("sendMessageYou", {
        token: this.token,
        name: "",
        msg: msg,
        token2: this.token,
        myself: false,
        channel: "",
        msg: msg,
        token: token,
      });

      addMsg(msg);
      if (bot_room) {
        sendMessageTobot(token, msg);
      }
    },

    sendMessageToBot(token, msg) {
      const isSSL = location.hostname == "localhost" ? "http" : "https";
      xhttp.open("POST", `${isSSL}://localhost/webhooks/rest/webhook`, true);
      xhttp.setRequestHeader("Content-Type", "application/json");
      xhttp.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhttp.send(JSON.stringify({ sender: token, message: msg }));
    },

    addMessage(msg) {
      var div = document.createElement("div");
      div.innerHTML = `<span style='flex-grow:1'></span><div class='message-bubble max-lines' style="border-radius: 20px 20px 2px 20px;background-color: rgb(0,29,132,.1);"> </div>`;
      div.className = "message-bubble-div";
      div.querySelector("div").innerText = msg;
      document.getElementById("message-box").appendChild(div);
      scrollToBottom();
    },

    addResponseMessage(msg) {
      var div = document.createElement("div");
      div.innerHTML = `<div class='message-bubble max-lines' style="border-radius: 20px 20px 20px 2px">${msg}</div>`;
      div.className = "message-bubble-div";
      document.getElementById("message-box").appendChild(div);
      scrollToBottom();
    },

    addOptions(msg) {
      var div = document.createElement("div");
      div.innerHTML = msg;
      document.getElementById("message-box").appendChild(div);
      scrollToBottom();

      const buttons = document.querySelectorAll(".button-option-queue");
      buttons.forEach((btn) => {
        btn.addEventListener("click", (e) => {
          let queue = e.target.value;
          let text = e.target.textContent;
          addMsg(text);
          addResponseMsg("Para agilizar poderia me informar o seu CPF?");
          socket.emit("sendMeToQueue", queue);
          disableOptions();
        });
      });
    },

    disableOptions() {
      let el = document.getElementById("options-queue");
      el.parentNode.removeChild(el);
    },

    scrollToBottom() {
      try {
        let objDiv = document.getElementById("message-box");
        objDiv.scrollTop = objDiv.scrollHeight;
      } catch {
        return;
      }
    },
    
    hideChat() {
      this.chatVisibility = false;
    },

    showChat() {
      this.chatVisibility = true;
    }
  },
};
</script>

<style lang="scss" scoped>
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(#d88339, 0.4);
  }

  75%, 100% {
    box-shadow: 0 0 0 2rem rgba(#d88339, 0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

body {
  /* height: calc(100vh - 32px); */

  /* margin : 0px; */
  /* background-image: url('data:image/svg+xml,%3Csvg width="52" height="26" viewBox="0 0 52 26" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%239C92AC" fill-opacity="0.4"%3E%3Cpath d="M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z" /%3E%3C/g%3E%3C/g%3E%3C/svg%3E'); */
  /* background-image: url('ger.png'); */
  background-repeat: no-repeat;
}

.main-card {
  font-family: Roboto, sans-serif;
  background: white;
  color: white;
  /* width: 80%; */
  max-width: 300px;
  height: calc(100% - 32px);
  /* max-height:280px; */
  max-height: 500px;
  margin: 16px auto;
  border-radius: 8px;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: height 2s;
}

.main-card {
  position: fixed;
  bottom: 1em;
  right: 1em;
  border: 3px solid #f1f1f1;
  z-index: 9999;
}

.header-chat {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #cccccc;
  font-size: large;
  font-weight: bold;
  padding: 1em 1.5em;
  font-size: 2em;
}

.button-close {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.chat-area {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 10px;
}

.input-message {
  padding: 8px 24px;
  flex-grow: 1;
  margin: 0px 8px 0px 0px;
  border-radius: 24px;
  border: none;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.input-message:focus {
  outline: none;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
}

.input-div {
  height: 48px;
  width: calc(100% - 32px);
  margin: 16px;
  display: flex;
}

.input-send {
    color: #FFF;
    font-size: 1.5em;
  background: #d88339;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  border: none;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.input-send:hover {
  cursor: pointer;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.25);
}

.input-send svg {
  fill: white;
  margin: 11px 8px;
}

.message-bubble {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  margin: 10px 0px;
  padding: 40px;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.11);
  color: black;
  border-radius: 50px;
}

.message-bubble small {
  align-self: flex-end;
  color: rgba(0, 0, 0, 0.203);
}

.received {
    color: #fff;
    border-radius: 20px 20px 0px 20px;
    background-color: #d88339;
}

.sent {
    border-radius: 20px 20px 20px 0px;
    background-color: #fff;
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.open-button {
  border-radius: 100%;
  background-color: #d88339;
  color: white;
  padding: 16px 18px;
  cursor: pointer;
  position: fixed;
  bottom: 2em;
  right: 2em;
  z-index: 9999;
  box-shadow: 0 0 0 -2px rgba(black, 1), 0 2px 4px 0 rgba(black, 0.3);
  transition: box-shadow 250ms ease;

  &:hover {
    box-shadow: 0 16px 10px -8px rgba(black, 0.3), 0 4px 10px 0 rgba(black, 0.2);
  }

  &::before,
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    border-radius: 50%;
    animation: pulse 2s ease-in-out 5;
  }
  &::after {
    animation-delay: 0.5s;
  }
}

.hideChat {
  display: none;
  max-height: 0px;
}

.max-lines {
  display: block; /* or inline-block */
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
  /* line-height: 1.8em; */
}

.intro {
  color: black;
  margin: 0;
  font-style: italic;
  text-align: center;
}

.contain-svg > img {
  width: 100%;
}

.contain-svg:nth-child(1) {
  height: 50px;
  width: 50px;
}

.contain-svg:nth-child(2) {
  height: 200px;
  width: 200px;
}

.contain-svg {
  float: left;
  margin: 10px;
}

.button-option-queue {
  width: 100%;
  cursor: pointer;
  margin-top: 0.4em;
  padding: 1em;
  background-color: white;
  border: solid 1px;
  border-radius: 0.4em;

  text-align: left;
}

.button-option-queue:hover {
  color: white;
  background-color: #d88339;
}

</style>
